<template>
  <ak-drawer
    :active="service.active.value"
    has-backdrop
    show-overlay
    show-highest
    paddingless
    min-width="50%"
    @close="service.reset"
  >
    <template #body>
      <ak-form class="h-full" @submit="service.process()">
        <component
          :is="service.configurator.value"
          :v-if="service.configurator.value"
          :service="service"
        />
      </ak-form>
    </template>
  </ak-drawer>
</template>

<script>
import { defineComponent } from 'vue'

import IntegrationSFTPCreateLead from './operations/create_lead/IntegrationSFTPCreateLead.vue'

export default defineComponent({
  name: 'AkIntegrationSFTPOperation',
  components: {
    [IntegrationSFTPCreateLead.name]: IntegrationSFTPCreateLead,
  },
  props: {
    service: {
      required: true,
      type: Object,
    },
  },
})
</script>
